import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { catchAsync, IS_SUCCESS_RESPONSE } from 'src/helpers'
import { useAuth } from 'src/modules/Auth/Core'
import ProjectEnquiryRequestForm from 'src/modules/ProjectEnquiryRequest/ProjectEnquiryRequestForm'
import { MAIN_ROUTES_CONST } from 'src/navigations/modules'
import { submitProjectEnquiryRequestApiRequest } from 'src/services/requests/ProjectEnquiryRequest'
import CustomeDialog from 'src/shadcn/components/custom/CustomeDialog'
import LoadingDialog from 'src/shadcn/components/custom/LoadingDialog'

type Props = {}

const ProjectEnquiryRequestMainPage = (props: Props) => {

    const [isLoading, setisLoading] = useState<boolean>(false)
    const [showSuccessDialog, setshowSuccessDialog] = useState<boolean>(false)
    const navigate = useNavigate()
    const { currentUser } = useAuth()

    if (!currentUser) {
        navigate('/' + MAIN_ROUTES_CONST.login)
    }

    const handleSubmitProjectRequest = catchAsync(async (data: any) => {
        setisLoading(true)
        return await submitProjectEnquiryRequestApiRequest(data)
    }, (result: any) => {
        if (IS_SUCCESS_RESPONSE(result)) {
            setisLoading(false)
            setshowSuccessDialog(true)
        }
    }, () => { setisLoading(false) })

    return (
        <>
            <div className='max-w-[80vw] mx-auto py-4 '>
                <div>
                    <div className='text-xl text-primary uppercase'>ENQUIRY FORM</div>
                    <div className='h-0.5 bg-primary w-[50px] rounded-full'></div>
                    <div className='my-4 text-sm'>Please fill the form below.</div>
                    <div className='p-4' >
                        <ProjectEnquiryRequestForm onSubmit={handleSubmitProjectRequest} />
                    </div>
                </div>
            </div>
            <LoadingDialog isOpen={isLoading} />
            <CustomeDialog isOpen={showSuccessDialog} headerTitle={"Request Sent"} hideDefaultCancle onSubmit={() => {
                setshowSuccessDialog(false)
                navigate("/")
            }}  >
                <p className='mb-2'>
                    Your request has been sent successfully. our team will get back to you in 24-48 hours.
                </p>
            </CustomeDialog>
        </>
    )
}

export default ProjectEnquiryRequestMainPage